import { render, staticRenderFns } from "./PromoEditForm.vue?vue&type=template&id=3021ba0f&scoped=true&"
import script from "./PromoEditForm.vue?vue&type=script&lang=js&"
export * from "./PromoEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3021ba0f",
  null
  
)

export default component.exports